import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type';
import { fetchApi } from '@/config/axiosSetting';
import {
  GetEducationListQueryParamsType,
  GetEducationListQueryResponseType,
} from './getEducationListQuery.type';

type GetEducationListFunctionParamsType = GetEducationListQueryParamsType & {
  page?: number;
};

export const getEducationListFunction = (
  params: GetEducationListFunctionParamsType,
): Promise<PaginationResponseType<GetEducationListQueryResponseType>> => {
  const { categories, page, ...restParams } = params;

  return fetchApi.get('/education/list/', {
    params: {
      ...restParams,
      ...(page !== undefined ? { page } : {}),
      ...(categories?.length ? { categories: categories.join(',') } : {}),
    },
  });
};
